import { useTranslation } from "react-i18next"

import styles from "../styles/file-viewer.module.css"

type FallbackViewerProps = {
  fileUrl: string
}

/**
 * Renders a message for file types that are not yet supported.
 */
export function FallbackViewer({ fileUrl }: FallbackViewerProps) {
  const { t } = useTranslation()

  const title =
    fileUrl == ""
      ? t("analysispanel.fileviewer.file_not_found")
      : t("analysispanel.fileviewer.preview_unavailable")
  return (
    <div className={styles.fallbackViewer}>
      <h2>{title}</h2>
    </div>
  )
}
